<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="keepalive" />
    </keep-alive>
    <router-view v-if="!keepalive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    keepalive() {
      return this.$route.meta.keepalive
    }
  },
  created() {
  },
  mounted() {
    document.body.addEventListener('touchstart', () => {})
  }
}
</script>

<style lang="scss">
  @import "css/app";
</style>



// WEBPACK FOOTER //
// src/App.vue